const buildInputNode = (nodeName, attributes, content, propertyPath) => {
  return `<${nodeName} ${attributes}>${content}<span data-prop="${propertyPath}" data-editable="input" style="display:none;"></span></${nodeName}>`
}

export default buildInputNode
